import {checkUser} from '../../sagas/routines/userRoutines';
import {commandCenterLogin} from './authRoutines';
import {connect} from 'react-redux';
import Container from '@material-ui/core/Container';
import React from 'react';
import {useFusionAuth} from "@fusionauth/react-sdk";

const Login = ({auth}) => {
    const { login, logout, register, isAuthenticated } = useFusionAuth();

    React.useEffect(() => {
        //IF Platform is event farm, and user is unauthenticated, trigger auth0 auth flow
        if ( !isAuthenticated) {
            login()
        }
    }, [])
    return (
        <Container component="main" maxWidth="xs">

        </Container>
    );
};

function mapStateToProps(state) {
    return {auth: state.auth};
}

const mapDispatchToProps = {
    checkUser,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(Login);
